// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./navbar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./home.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./footer.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!./about.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js!./menu.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js!./historyMenus.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js!./classification.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

.main-content-wrapper {
  min-height: 100vh;
}

.top-progress-bar-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  z-index: 100001;
  pointer-events: none;
}

.top-progress-bar {
  height: 100%;
  width: 0;
  background-color: #ffa559;
  box-shadow: 0 0 8px rgba(255, 165, 89, 0.7);
  transition:
    width 0.3s ease,
    opacity 0.4s ease;
  opacity: 0;
}

/* Animation: Fade In + Slide Up */
.page-transition {
  opacity: 0;
  transform: translateY(15px);
  transition:
    opacity 0.4s ease-out,
    transform 0.4s ease-out;
}

.page-transition.active {
  opacity: 1;
  transform: translateY(0);
}

.analysis-loader {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  display: none;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  z-index: 10;
}

.analysis-loader.active {
  display: flex;
}

.analysis-spinner {
  width: 40px;
  height: 40px;
  border: 6px solid #ffe0b2;
  border-top: 6px solid #ffa559;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.lazyload {
  opacity: 0;
  transition: opacity 0.5s;
}
.lazyloaded {
  opacity: 1;
}

.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.popup-overlay.active {
  opacity: 1;
  visibility: visible;
}

.popup-box {
  background: white;
  padding: 2.5rem;
  border-radius: 1.5rem;
  width: 90%;
  max-width: 400px;
  transform: scale(0.8);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.popup-overlay.active .popup-box {
  transform: scale(1);
}

.popup-message {
  font-size: 1.1rem;
  color: #333;
  font-weight: 500;
}

.popup-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.popup-message {
  font-weight: 600;
  color: #444;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 580px) {
  .go-to-top {
    width: 35px;
    height: 35px;
    font-size: 22px;
    line-height: 0;
    border-radius: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AASA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,2CAA2C;EAC3C;;qBAEmB;EACnB,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,2BAA2B;EAC3B;;2BAEyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import \"navbar.css\";\n@import \"home.css\";\n@import \"footer.css\";\n@import \"about.css\";\n@import \"menu.css\";\n@import \"historyMenus.css\";\n@import \"classification.css\";\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.main-content-wrapper {\n  min-height: 100vh;\n}\n\n.top-progress-bar-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  z-index: 100001;\n  pointer-events: none;\n}\n\n.top-progress-bar {\n  height: 100%;\n  width: 0;\n  background-color: #ffa559;\n  box-shadow: 0 0 8px rgba(255, 165, 89, 0.7);\n  transition:\n    width 0.3s ease,\n    opacity 0.4s ease;\n  opacity: 0;\n}\n\n/* Animation: Fade In + Slide Up */\n.page-transition {\n  opacity: 0;\n  transform: translateY(15px);\n  transition:\n    opacity 0.4s ease-out,\n    transform 0.4s ease-out;\n}\n\n.page-transition.active {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.analysis-loader {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.85);\n  display: none;\n  justify-content: center;\n  align-items: center;\n  border-radius: 1rem;\n  z-index: 10;\n}\n\n.analysis-loader.active {\n  display: flex;\n}\n\n.analysis-spinner {\n  width: 40px;\n  height: 40px;\n  border: 6px solid #ffe0b2;\n  border-top: 6px solid #ffa559;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.lazyload {\n  opacity: 0;\n  transition: opacity 0.5s;\n}\n.lazyloaded {\n  opacity: 1;\n}\n\n.popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n}\n\n.popup-overlay.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n.popup-box {\n  background: white;\n  padding: 2.5rem;\n  border-radius: 1.5rem;\n  width: 90%;\n  max-width: 400px;\n  transform: scale(0.8);\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.popup-overlay.active .popup-box {\n  transform: scale(1);\n}\n\n.popup-message {\n  font-size: 1.1rem;\n  color: #333;\n  font-weight: 500;\n}\n\n.popup-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.popup-message {\n  font-weight: 600;\n  color: #444;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 580px) {\n  .go-to-top {\n    width: 35px;\n    height: 35px;\n    font-size: 22px;\n    line-height: 0;\n    border-radius: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
